import React from "react";
import _ from "lodash";
import { CSVLink } from "react-csv";
import SimpleDataTable from "components/common/SimpleDataTable";
import Pagination from "components/common/Pagination";

class SourceDataView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNum: 15,
      pageIdx: 0,
      inputSearch: "",
    };

    this.handleSearchChanged = this.handleSearchChanged.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.records !== this.props.records) {
      this.setState({ pageIdx: 0 });
    }
  }

  handleSearchChanged(e) {
    this.setState({ inputSearch: e.target.value, pageIdx: 0 });
  }

  render() {
    const { records, columns, fileName } = this.props;

    const { pageIdx, inputSearch, pageNum } = this.state;

    const filterData = _.filter(records, (r) => {
      const dateIdx = _.findIndex(columns, { key: "date" });
      const extGamUnitIdIdx = _.findIndex(columns, { key: "ext_gam_unit_id" });
      return (
        (dateIdx >= 0 && r[dateIdx].includes(inputSearch)) ||
        (extGamUnitIdIdx >= 0 &&
          r[extGamUnitIdIdx].toString().includes(inputSearch))
      );
    });

    const pageRec = filterData.slice(
      pageIdx * pageNum,
      (pageIdx + 1) * pageNum
    );

    const csvData = [columns.map((d) => d.label), ...filterData];

    return (
      <>
        <div className="mb-2 flex justify-between">
          <input
            type="text"
            className="rounded focus:outline-none hover:shadow flex w-1/3 appearance-none border-2 border-gray-300 bg-white px-2 py-1 leading-normal hover:border-blue-300 focus:border-blue-400 focus:shadow-inner"
            placeholder="Search Date or Ext Gam Unit Id"
            onChange={this.handleSearchChanged}
            value={inputSearch}
          ></input>
          <CSVLink
            data={csvData}
            separator=","
            filename={fileName}
            className="shadow rounded bg-blue-200 px-4 py-2 font-medium text-blue-800 hover:bg-blue-300"
          >
            Download CSV
          </CSVLink>
        </div>
        <div className="mb-2">
          <SimpleDataTable items={pageRec} columns={columns}></SimpleDataTable>
        </div>
        {filterData.length > 0 && (
          <Pagination
            pageNum={pageNum}
            pageIdx={pageIdx}
            total={filterData.length}
            handlePageChanged={(pIdx) => this.setState({ pageIdx: pIdx })}
          ></Pagination>
        )}
      </>
    );
  }
}

export default SourceDataView;
